import { Button } from '@mui/material';

import { useSyncDevicesDialog } from '../../SyncDevices/SyncDevices.hooks';
import useStyles from './ViewSyncStatus.styles';

/**
 * Renders the sync status action for viewing in-progress changes.
 *
 * @returns Sync status action row.
 */
const ViewSyncStatus = () => {
  const { openSyncDevicesDialog } = useSyncDevicesDialog();
  const { classes } = useStyles();

  const handleViewChanges = () => {
    openSyncDevicesDialog('viewSyncInProgress');
  };

  return (
    <>
      <div className={classes.flexLeftCol}>Sync Changes</div>
      <div className={classes.flexRightCol}>
        <Button
          variant="text"
          size="small"
          color="warning"
          onClick={handleViewChanges}
          sx={{ marginTop: '-0.25rem', marginLeft: '-0.25rem' }}
        >
          View Changes
        </Button>
      </div>
    </>
  );
};

export default ViewSyncStatus;
